(() => {
  function syncPlan(select) {
    const option = select.selectedOptions[0];
    const form = select.closest('form');
    const price = form.closest('.tls-product-grid').querySelector('[data-product-price]');
    if (price && option) price.textContent = option.dataset.price || '';
    const description = form.querySelector('[data-plan-description]');
    if (description) description.textContent = option?.dataset.description || '';
  }
  function initialize(root) { root.querySelectorAll('[data-selling-plan]').forEach(syncPlan); }
  document.addEventListener('change', event => { if (event.target.matches('[data-selling-plan]')) syncPlan(event.target); });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.tls-header details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); }); });
  document.addEventListener('click', event => { document.querySelectorAll('.tls-header details[open]').forEach(detail => { if (!detail.contains(event.target)) detail.open = false; }); });
  initialize(document);
})();
document.addEventListener('shopify:block:select', function(event) { const row=event.target.closest('details.editable-accordion-item'); if(row) row.open=true; });

document.addEventListener('shopify:block:select', function(event) { const story=event.target.closest('details[data-editor-story]'); if(story) story.open=true; });
